import { useScrollLock } from '@/lib/useScrollLock';
import styles from './BusyOverlay.module.css';

interface Props {
  active: boolean;
  // Optionaler Verlaufstext unter dem Spinner (z.B. „Lädt hoch … (2/5)").
  text?: string;
  // Optionaler Byte-Fortschritt → echter Balken + „x,x / y,y MB".
  progress?: { loaded: number; total: number };
  // Gebietsschema der MB-Anzeige (Standard deutsch; der Self-Service übergibt es je Sprache).
  locale?: string;
}

const fmtMb = (bytes: number, locale: string) =>
  (bytes / 1048576).toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });

// UI-sperrendes Overlay mit Spinner + weißer Box. Sperrt zusätzlich das
// Seiten-Scrollen, solange es sichtbar ist. Zentraler Baustein für alle
// „bitte warten"-Zustände (Speichern/Upload) — einmal anpassen, überall gültig.
export default function BusyOverlay({ active, text, progress, locale = 'de-DE' }: Props) {
  useScrollLock(active);
  if (!active) return null;
  const pct = progress && progress.total > 0
    ? Math.min(100, Math.round((progress.loaded / progress.total) * 100))
    : null;
  return (
    <div className={styles.overlay} role="status" aria-live="polite" aria-label={text ?? 'Bitte warten …'}>
      <div className={styles.box}>
        <span className={styles.spinner} />
        {pct !== null && progress && (
          <>
            <div className={styles.bar}><div className={styles.barFill} style={{ width: `${pct}%` }} /></div>
            <span className={styles.mb}>{fmtMb(progress.loaded, locale)} / {fmtMb(progress.total, locale)} MB</span>
          </>
        )}
        {text && <span className={styles.text}>{text}</span>}
      </div>
    </div>
  );
}
